import { Box, Paper, Stack, Typography } from '@mui/material';

export default function ProjectVitalActivityView() {
  return (
    <Stack spacing={3}>
      <Box>
        <Typography component="h1" sx={{ fontWeight: 850, fontSize: { xs: '1.8rem', md: '2.2rem' }, letterSpacing: '-0.7px' }}>
          Actividad
        </Typography>
        <Typography color="text.secondary" sx={{ mt: 0.75 }}>
          Cronología de los cambios realizados en Proyecto Vital.
        </Typography>
      </Box>

      <Paper
        variant="outlined"
        sx={{
          p: 2.5,
          borderRadius: 3,
          bgcolor: '#1C293A',
          borderColor: 'rgba(255,255,255,0.08)',
        }}
      >
        <Typography sx={{ fontWeight: 750 }}>
          Sin actividad todavía.
        </Typography>
        <Typography color="text.secondary" sx={{ mt: 1 }}>
          La actividad se generará automáticamente cuando empieces a crear o actualizar registros.
        </Typography>
      </Paper>
    </Stack>
  );
}
